import Link from 'next/link';
import React from 'react';
import { PiCalendarBlank, PiPenNib } from 'react-icons/pi';
import { ApiRoutes, Routes } from '@/settings/routes';
import { format } from 'date-fns';

export default function ArticlesTerm({ articleData }) {
    const datArt = articleData.created_at ?? articleData.updated_at;
    const image = articleData?.miniature !== null ? ApiRoutes.ASSETS_ENDPOINT + articleData?.miniature : 'https://placehold.co/900x700';

    return (
        <div className="flex items-start flex-col gap-6">
            <div className="relative w-full min-h-48 max-h-64 flex items-end group overflow-hidden rounded">
                <span className="bg-gray-900/30 absolute z-10 top-0 left-0 w-full h-full"></span>
                <img
                    src={image}
                    className="size-full max-h-[500px] top-0 start-0 object-cover content-center group-hover:scale-105 transition-transform duration-500 ease-in-out"
                    alt={articleData.title}
                />
            </div>
            <div className="relative z-20 flex flex-col gap-3">
                <div className="flex items-center gap-4">
                    <span className="text-gray-400 text-sm transition-colors flex items-center gap-2">
                        <PiCalendarBlank className="h-5 w-5" />
                        {format(new Date(datArt), 'MMMM dd, yyyy')}
                    </span>
                    <span className="text-gray-400 text-sm transition-colors flex items-center gap-2">
                        <PiPenNib className="h-5 w-5" />
                        By <span className="text-gray-500">{articleData?.author?.user_name}</span>
                    </span>
                </div>
                <Link prefetch={false} href={`${Routes.FRONT_blog_article + articleData.slug}`}>
                    <h5 className="text-xl font-semibold default-color-title capitalize hover:text-custom-orange-900 transition-colors">{articleData.title}</h5>
                </Link>
                <p className="text-gray-400">{articleData.excerpt}</p>
            </div>
        </div>
    );
}
